import React from "react";

export const ParkFly = () => {
  return (
    <div className='top-indent'>
      <span className='title'>Fly over park:</span>
      &nbsp;
      &nbsp;
      &nbsp;
      &nbsp;
      <span>Yes</span>
      &nbsp;
      &nbsp;
      &nbsp;
      &nbsp;
      <span>No</span>
    </div>
  )}
